export class ProjectClient {
  id: string;
  logoPath: string;
  mainContactEmail: string;
  mainContactName: string;
  name: string;
}
